import cn from 'classnames';
import styles from './DetailCard.module.css';

type Props = {
  children: React.ReactNode;
  className?: string;
  /** If provided, this will be shown when the card is hovered (or the button is focused) */
  hoverButton?: React.ReactNode;
};

/** This component is used primarily on detail pages to offset sections from each other */
export function DetailCard({ className, hoverButton, children }: Props) {
  return (
    <section className={cn(styles.DetailCard, className)}>
      {children}
      {hoverButton ?
        <div className={styles.DetailCard_hoverButton}>{hoverButton}</div>
      : null}
    </section>
  );
}
